import React from 'react'
import Helmet from 'react-helmet'
import Footer from './Footer'
import config from '../configs/siteConfig'

export default function Layout ({title, children, location, locale, post, slug, isHome, amp }) {
  let sitePath = location.pathname;
  // title = post ? `${title} | ${config.siteTitleMeta}` : config.siteTitleMeta;
  title = post ? `${title}` : config.siteTitleMeta;
  let description = '';

  if (post) {
    description = post.frontmatter.description ?
        post.frontmatter.description : post.excerpt;
    sitePath = slug;
  } else {
    if (!sitePath.endsWith("/")) {
      sitePath = sitePath + "/";
    }
    description = config.siteDescriptionMeta;
  }

  let canonicalPath = sitePath;
  if (canonicalPath.startsWith('/ja/')) {
    canonicalPath = canonicalPath.replace('/ja/', '/ko/');
  } else if (canonicalPath.startsWith('/en/')) {
    canonicalPath = canonicalPath.replace('/en/', '/ko/');
  }
  if (canonicalPath === '/') {
    canonicalPath = '/ko/';
  }

  let robots = "index,follow";
  let mainHome = false;
  if (sitePath === '/' || sitePath === '/ko/') {
    mainHome = true;
  }
  if (!mainHome && !post) {
    robots = "noindex,nofollow";
  } else if (post && post.frontmatter.robots === 'hide') {
    robots = "noindex,nofollow";
  }
  // if (sitePath.startsWith('/en/')) {
  //   robots = "noindex,nofollow";
  // }

  let homeUrl = '/' + locale + '/';

  let keywords = post ? post.frontmatter.tags : config.keywords;

  let fontLink = ""
  if (!amp) {
    if (locale === 'ko') {
      // fontLink = <link crossorigin="anonymous" href="https://fonts.googleapis.com/css?family=Noto+Sans+KR&display=swap" rel="stylesheet"/>
      // fontLink = <link crossorigin="anonymous" href="https://fonts.googleapis.com/css?family=Nanum+Gothic:400&display=swap" rel="stylesheet"/>
      fontLink = <link crossOrigin="anonymous" href="//cdn.jsdelivr.net/font-nanum/1.0/nanumgothic/nanumgothic.css" rel="preload stylesheet"/>
    } else if (locale === 'ja') {
      fontLink = <link crossOrigin="anonymous" href="https://fonts.googleapis.com/css?family=Noto+Sans+JP:400&display=swap" rel="preload stylesheet"/>
    } else if (locale === 'en') {
      // fontLink = <link crossOrigin="anonymous" href="https://fonts.googleapis.com/css?family=Noto+Sans:400&display=swap" rel="preload stylesheet"/>
    }
  }

  return (
      <div>
        <Helmet
          title={title}
          meta={[
            { name: 'description', content: `${description}` },
            { name: 'keywords', content: `${keywords}` },
            { name: 'author', content: 'js' },
            { name: 'og:title', property: 'og:title', content: `${title}` },
            { name: 'og:description', property: 'og:description', content: `${description}` },
            { name: 'og:site_name', property: 'og:site_name', content: `${config.siteTitleMeta}` },
            { name: 'og:image ', property: 'og:image  ', content: `${config.siteLogo}` },
            { name: 'og:type', property: 'og:type', content: 'website' },
            { name: 'og:locale', property: 'og:locale', content: `${locale}` },
            { name: 'og:url', property: 'og:url', content: `${config.siteUrl}${sitePath}` },
            { name: 'twitter:title', content: `${title}`},
            { name: 'twitter:image', content: `${config.siteLogo}`},
            { name: 'twitter:card', content: 'summary'},
            { name: 'twitter:twitter_site', content: `${config.twitter}`},
            { name: 'twitter:description', content: `${description}`},
            { name: 'twitter:creator', content: `${config.authorTwitterAccount}` },
            { name: 'robots', content:`${robots}` }
          ]}
        >
          <html lang={locale} />
          <link rel="canonical" href={`${config.siteUrl}${canonicalPath}`} />
          {fontLink}
        </Helmet>

        <nav className="bg-blue do-not-print">
          <div className="header-border">
            <div className="navbar-brand ml-3 do-not-print">
              <a href={homeUrl} className="font-weight-normal">
                {config.shortTitle}
              </a>
            </div>
          </div>
        </nav>

        <main className="site-content bg-grey">
          {children}
        </main>
        <Footer />
      </div>
  );
}
